import { useGetUserEventsInfinite } from "api/generated/utils/utils";

import * as rp from "../types";

export const useUserEventsQuery = (
    startTimestamp: number,
    endTimestamp: number
) =>
    useGetUserEventsInfinite(
        { startTimestamp, endTimestamp },
        {
            query: {
                initialPageParam: "first",
                getNextPageParam: (lastPage) => lastPage.data.pagination.next,
                select: (data) => ({
                    events: data.pages
                        .flatMap((page) => page.data.content)
                        .map((dto) => dto.resource as rp.EventWithRelations),
                    users: Object.fromEntries(
                        data.pages
                            .flatMap((page) => page.data.linkedResources)
                            .map((user) => [user.id, user])
                    ),
                    lastPageEventIds: data.pages[
                        data.pages.length - 1
                    ].data.content.map((dto) =>
                        dto.resource.event.id.toString()
                    ),
                }),
            },
        }
    );
